module.exports = __webpack_public_path__ + "4.3.2/img/icon_2.d1d99cba.svg";